export default __webpack_public_path__ + "static/B0209-7b1aeb92a4fcfce3c73215b0598d0eff.png";